const REPLAY_FIELD_LABELS = {
  responsabilita: 'Responsabilità',
  stradale_tipo_incidente: 'Tipo Incidente',
  stradale_lesioni: 'Lesioni',
  stradale_prognosi: 'Prognosi',
  stradale_prove: 'Prove',
  stradale_lavoro: 'Lavoro',
  stradale_danni_mezzo: 'Danni Mezzo',
  ha_referto_medico: 'Referto Medico',
  autorita_intervenute: 'Autorità / CID',
  malasanita_tipo_errore: 'Tipo Errore',
  malasanita_gravita_conseguenze: 'Gravità Conseguenze',
  malasanita_documenti_medici: 'Documenti Medici',
  malasanita_esito_post_trattamento: 'Esito Post Trattamento',
  malasanita_impatto_vita_lavoro: 'Impatto Vita / Lavoro',
  malasanita_autorizzazione_medico_legale: 'Autorizzazione Medico Legale',
  evento_malasanita: 'Evento Malasanità',
  cartella_clinica_richiesta: 'Cartella Clinica',
  invalidita_o_decesso: 'Invalidità o Decesso',
  struttura_coinvolta: 'Struttura Coinvolta',
  esito_evento: 'Esito Evento',
};

const REPLAY_VALUE_LABELS = {
  responsabilita: {
    ragione_piena: 'Ragione piena',
    concorso_colpa: 'Concorso colpa',
    colpa_propria: 'Colpa propria',
    non_so: 'Non so',
  },
  stradale_tipo_incidente: {
    tamponamento: 'Tamponamento',
    scontro_laterale: 'Scontro laterale',
    frontale: 'Frontale',
    pedone: 'Pedone',
    moto: 'Moto',
    altro: 'Altro',
  },
  stradale_lesioni: {
    gravi: 'Gravi (intervento/ricovero)',
    moderate: 'Moderate (prognosi)',
    lievi: 'Lievi',
    nessuna: 'Nessuna',
  },
  stradale_prognosi: {
    gt_30gg: '>30 gg',
    '10_30gg': '10-30 gg',
    lt_10gg: '<10 gg',
    nessuna: 'Nessuna',
  },
  stradale_prove: {
    verbale_polizia: 'Verbale Polizia',
    testimoni: 'Testimoni',
    entrambi: 'Entrambi',
    nessuno: 'Nessuno',
  },
  stradale_lavoro: {
    incapacita_totale: 'Incapacità totale',
    incapacita_parziale: 'Incapacità parziale',
    no: 'No',
  },
  stradale_danni_mezzo: {
    grave: 'Gravemente danneggiato',
    medio: 'Medi (>1000€)',
    lievi: 'Lievi',
    nessuno: 'Nessuno',
  },
  malasanita_tipo_errore: {
    errore_chirurgico: 'Errore Chirurgico',
    errore_diagnostico: 'Errore diagnostico',
    infezione_ospedaliera: 'Infezione ospedaliera',
    non_sicuro: 'Non sono sicuro',
  },
  malasanita_gravita_conseguenze: {
    danno_lieve_temporaneo: 'Danno lieve o temporaneo',
    danno_permanente: 'Danno permanente',
    decesso_paziente: 'Decesso del paziente',
    non_so_definire: 'Non so definire',
  },
  malasanita_documenti_medici: {
    cartella_clinica_completa: 'Cartella clinica completa',
    referti_ed_esami: 'Referti ed esami',
    perizia_medico_legale: 'Perizia medico-legale',
    solo_documenti_sparsi: 'Solo documenti sparsi',
    nulla: 'Nulla',
  },
  malasanita_esito_post_trattamento: {
    reintervento_peggioramento: 'Re-intervento / Peggioramento',
    infezione_complicazioni: 'Infezione / Complicazioni',
    nuovo_ricovero: 'Nuovo ricovero',
    nessun_peggioramento: 'Nessun peggioramento',
  },
  malasanita_impatto_vita_lavoro: {
    incapacita_totale: 'Incapacità totale',
    incapacita_parziale: 'Incapacità parziale',
    no: 'No',
  },
  malasanita_autorizzazione_medico_legale: {
    si_autorizzo: 'Sì, autorizzo',
    no_preferisco_parlarne_prima: 'No, preferisco parlarne prima',
  },
  evento_malasanita: {
    errore_chirurgico: 'Errore Chirurgico',
    infezione_ospedaliera: 'Infezione ospedaliera',
    ritardo_diagnostico: 'Ritardo diagnostico',
    caduta_in_struttura: 'Caduta in struttura',
    altro: 'Altro',
  },
  cartella_clinica_richiesta: {
    si: 'Sì',
    no: 'No',
    in_attesa: 'In attesa',
  },
  invalidita_o_decesso: {
    si: 'Sì',
    no: 'No',
  },
  esito_evento: {
    errore_chirurgico: 'Errore Chirurgico',
    infezione_ospedaliera: 'Infezione ospedaliera',
    ritardo_diagnostico: 'Ritardo diagnostico',
    caduta_in_struttura: 'Caduta in struttura',
    altro: 'Altro',
  },
  ha_referto_medico: { si: 'Sì', no: 'No' },
  autorita_intervenute: { si: 'Sì', no: 'No' },
};

export function isBlankReplayValue(value) {
  if (value === null || value === undefined) return true;
  if (typeof value === 'string') {
    const trimmed = value.trim();
    return trimmed === '' || trimmed.toLowerCase() === 'null';
  }
  return false;
}

function humanizeFieldKey(key) {
  if (REPLAY_FIELD_LABELS[key]) return REPLAY_FIELD_LABELS[key];
  return String(key || '')
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

export function formatReplayValue(fieldKey, value) {
  const normalized = String(value ?? '').trim();
  const fieldMap = REPLAY_VALUE_LABELS[fieldKey];
  if (fieldMap && fieldMap[normalized]) return fieldMap[normalized];
  if (normalized === 'si') return 'Sì';
  if (normalized === 'no') return 'No';
  return normalized.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
}

export function getReplayEntries(changes) {
  if (!changes || typeof changes !== 'object' || Array.isArray(changes)) return [];
  return Object.entries(changes)
    .filter(([, value]) => !isBlankReplayValue(value))
    .map(([key, value]) => ({
      key,
      label: humanizeFieldKey(key),
      value: formatReplayValue(key, value),
    }));
}

export function LeadReplayHistory({ replay }) {
  const events = Array.isArray(replay) ? replay : [];
  const visibleEvents = events
    .map((event, index) => ({
      index,
      timestamp: event?.timestamp,
      entries: getReplayEntries(event?.changes),
    }))
    .filter((event) => event.entries.length > 0);

  if (visibleEvents.length === 0) {
    return (
      <div className="replay-box">
        <h3 className="replay-title">Storico Risposte</h3>
        <p className="replay-empty">Nessuna risposta registrata.</p>
      </div>
    );
  }

  return (
    <div className="replay-box">
      <h3 className="replay-title">Storico Risposte</h3>
      {visibleEvents.map((event) => (
        <div key={event.index} className="replay-item">
          {event.timestamp && (
            <p className="replay-timestamp">
              {new Date(event.timestamp).toLocaleString('it-IT', {
                dateStyle: 'medium',
                timeStyle: 'short',
              })}
            </p>
          )}
          <div className="replay-answers-grid">
            {event.entries.map(({ key, label, value }) => (
              <div key={key} className="replay-answer-card">
                <p className="replay-answer-label">{label}</p>
                <p className="replay-answer-value">{value}</p>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
